import { TBody, Th, THead, Tr } from '../../../shared/Table';
import { DataForDesignDrawingsManifold } from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { FloorCoveringRow } from '../../shared/manifold-table/FloorCoveringRow';
import { FloorTemperatureLimit } from '../../shared/manifold-table/FloorTemperatureLimit';
import { HeatLossRow } from '../../shared/manifold-table/HeatLossRow';
import { HeatOutputRow } from '../../shared/manifold-table/HeatOutputRow';
import { MaxDesignFloorTemperature } from '../../shared/manifold-table/MaxDesignFloorTemperature';
import { PortsRow, PortsRowWidths } from '../../shared/manifold-table/PortsRow';
import { RoomTemperatureRow } from '../../shared/manifold-table/RoomTemperatureRow';
import { ShortfallRow } from '../../shared/manifold-table/ShortfallRow';
import { ManifoldDiagramTable } from './ManifoldDiagramWithTable';

type Props = {
  manifold: DataForDesignDrawingsManifold;
  portsRowWidths: PortsRowWidths;
  numberOfPorts: number;
  className?: string;
};

export const ManifoldDiagramBottomTable = ({ manifold, portsRowWidths, numberOfPorts, className }: Props) => {
  return (
    <ManifoldDiagramTable className={className}>
      <THead>
        <Tr>
          <Th colSpan={numberOfPorts + 1}>Heat Loss and Outputs</Th>
        </Tr>
        <PortsRow numberOfPorts={numberOfPorts} portsRowWidths={portsRowWidths} />
      </THead>
      <TBody>
        <RoomTemperatureRow manifold={manifold} displayStyle="PerRoom" />
        <HeatLossRow manifold={manifold} displayStyle="PerRoom" precision={1} />
        <HeatOutputRow manifold={manifold} displayStyle="PerRoom" precision={1} />
        <FloorCoveringRow manifold={manifold} />
        <FloorTemperatureLimit manifold={manifold} displayStyle="PerRoom" />
        <MaxDesignFloorTemperature manifold={manifold} displayStyle="PerRoom" />
        <ShortfallRow manifold={manifold} roundValuesLessThan100ToZero={true} displayStyle="PerRoom" />
      </TBody>
    </ManifoldDiagramTable>
  );
};
